<template>
  <div class="page-dialog">
    <el-form
      ref="productForm"
      label-position="right"
      :inline="true"
      size="mini"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="产品编码">
            <el-input v-model="conditions.productId" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="产品描述">
            <el-input v-model="conditions.productName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目类型名称">
            <el-input v-model="conditions.rewardName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tl">
        <el-button type="default" icon="el-icon-refresh-right" size="mini" @click="reset">重置</el-button>
        <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading" @click="queryData">查询</el-button>
      </el-row>
    </el-form>

    <div class="table-container">
      <TableCommon
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="400"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>

  </div>
</template>

<script>
import { getCashReward } from '@/api/sap/reward-policy'
export default {
  props: {
    queryParams: {
      type: Object,
      default: () => {
        return { customerCode: '' }
      }
    },
    isAuth: {
      type: Boolean,
      default: false
    },
    isRadio: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        productId: '',
        productName: '',
        rewardName: '',
      },
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 40 },
          {
            field: 'reward_id',
            title: '奖励类型编码',
            width: 120
          },
          {
            field: 'reward_name',
            title: '项目类型描述',
            width: 180
          },
          {
            field: 'product_id',
            title: '产品编码',
            width: 150
          },
          {
            field: 'product_name',
            title: '产品名称',
            width: 180
          },
          {
            field: 'start_date',
            title: '有效期起',
            width: 100
          },
          {
            field: 'end_date',
            title: '有效期止',
            width: 100
          },
          {
            field: 'quota_ratio',
            title: '额度比例(%)',
          },
          // {
          //   field: 'status',
          //   title: '状态',
          //   width: 80
          // }
        ],
        data: []
      }
    }
  },
  computed: {},
  created() {
    if (!this.isRadio) {
      this.gridOptions.columns[0].type = 'checkbox'
      this.gridOptions.columns[0].field = 'checkbox'
    }
  },
  methods: {
    cellClick({ row }) {
      if (this.isRadio) {
        this.$refs.gridOptions.setRadioRow(row)
      } else {
      }
    },
    // 查询
    async queryData() {
      // if (this.isAuth && !this.queryParams.customerCode) {
      //   return this.$message.warning('请先选择客户！')
      // }
      this.loading = true
      try {
        const now = new Date();
        const year = now.getFullYear().toString();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const dateTime = year  + month  + day

        const params = {
          user_bp: this.$store.getters.role.USER_BP,
          role: this.$store.getters.role.ROLE,
          start_date: [{sign: "I", option: "LE", low: dateTime, high: ""}],
          end_date: [{sign: "I", option: "GE", low: dateTime, high: ""}],
          product_id: [{sign: "I", option: "CP", low: "*"+this.conditions.productId+"*", high: ""}],
          reward_name: [{sign: "I", option: "CP", low: "*"+this.conditions.rewardName+"*", high: ""}],
          product_name: [{sign: "I", option: "CP", low: "*"+this.conditions.productName+"*", high: ""}],
          status: [{sign: "I", option: "EQ", low: "V001", high: ""}],
          ...this.pagination
        }
        !this.conditions.productId && delete params.product_id
        !this.conditions.rewardName && delete params.reward_name
        !this.conditions.productName && delete params.product_name
        const res = await getCashReward(params)
        if (res?.msgtype === 'S') {
          this.gridOptions.data = res.data
          this.pagination.totalCount = +res.total
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    reset() {
      this.conditions = {
        productId: '',
        rewardName: ''
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      if (this.isRadio) {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        if (selectData) {
          console.log(`output->selectData`,selectData)
          
        }
        return Promise.resolve(selectData)
      } else {
        const selectData = this.$refs.gridOptions.getCheckboxRecords()
        if (selectData.length) {
          selectData.forEach(item => {
            item.productShortName = item.SHORT
            item.productCode = item.PRODUCT_ID
            item.description = item.SHORT_TEXT
            item.brandBqTextView = item.BRAND_BQ_D
            item.containerNum = item.CAPTY
          })
        }
        return Promise.resolve(selectData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/reward-policy/components/rewardProjectData.vue